/** 分摊账单 /metering/bill/split-bill（splittheBill.vue） */
export default {
  splitBillPage: {
    phDateStart: '开始日期',
    phDateEnd: '结束日期',
    phShareGroup: '公摊组',
    phShareType: '公摊类型',
    shareTypeElec: '用电公摊',
    shareTypeWater: '用水公摊',
    shareTypeShort: '公摊',
    btnSearch: '查询',
    btnReset: '重置',
    btnExport: '导出',
    sectionTitle: '分摊账单列表',
    sortDefault: '默认排序',
    selectedLine: '已选择 <span class="count">{count}</span> 条数据',
    colRid: '结算ID',
    colOccurDate: '结算日期',
    colShareId: '公摊组ID',
    colShareName: '公摊组名',
    colShareType: '公摊类型',
    colBalance: '总结算金额',
    colTotalArea: '总公摊面积',
    colSettleStatus: '结算状态',
    colAction: '操作',
    btnDetail: '详情',
    drawerTitleAll: '公摊结算详情',
    drawerTitleElec: '用电公摊结算详情',
    drawerTitleWater: '用水公摊结算详情',
    descSettleId: '结算ID',
    descSettleDate: '结算日期',
    descShareGroupId: '公摊组ID',
    descShareGroupName: '公摊组名',
    descTotalAmount: '总结算金额',
    descTotalArea: '总公摊面积',
    descSettleStatus: '结算状态',
    dividerDetail: '分摊明细',
    colDeviceId: '设备ID',
    colDeviceName: '设备名称',
    colBindType: '类型',
    colUseKwh: '用能(kwh)',
    colAlarm: '警告',
    colTenant: '租户',
    tenantIdPrefix: 'ID:',
    colShareBalance: '分摊金额(元)',
    colSharePercent: '分摊占比',
    colSumUse: '合计用能(kwh)',
    colArea: '实用面积(㎡)',
    colDefaultPublicArea: '默认公摊面积(㎡)',
    emptyNoDetail: '暂无分摊明细',
    status0: '未结算',
    status1: '已结算',
    status2: '结算中',
    status3: '结算失败',
    statusUnknown: '未知',
    deviceTypeDedicated: '专用表',
    deviceTypeShare: '公摊组',
    deviceTypeDash: '-',
    msgShareListFail: '获取公摊组列表失败',
    msgFetchFail: '获取公摊账单数据失败',
    msgMissingFeeId: '缺少分摊账单ID',
    msgDetailFail: '获取详情失败',
    msgNoDataExport: '暂无数据可导出',
    msgExportOk: '成功导出{count}条数据！',
    msgExportOkSelected: '成功导出{count}条选中数据！',
    msgExportFail: '导出失败，请重试',
    exportSheetName: '公摊组账单',
    filePrefixAll: '公摊账单',
    filePrefixElec: '用电公账单',
    filePrefixWater: '用水公账单',
    unitSqm: '㎡',
    // 导出（本页/选中/全部）统一文案
    exportCurrentPage: '导出本页',
    exportSelected: '导出选中',
    exportAll: '导出全部',
    warnNoSelectedExport: '请先选择要导出的数据',
    successExported: '导出成功，共 {count} 条',
    successExportedLimit: '命中 {total} 条，单次最多导出 {count} 条，已导出前 {count} 条',
    exporting: '正在导出全部数据...'
  }
}
